export const PUBLIC_JOB_OFFERS_GET_REQUEST = 'public-job-offers-get-request';
export const PUBLIC_JOB_OFFERS_GET_SUCCESS = 'public-job-offers-get-success';
export const PUBLIC_JOB_OFFERS_GET_FAILURE = 'public-job-offers-get-failure';

export const PUBLIC_JOB_OFFER_GET_REQUEST = 'public-job-offer-get-request';
export const PUBLIC_JOB_OFFER_GET_SUCCESS = 'public-job-offer-get-success';
export const PUBLIC_JOB_OFFER_GET_FAILURE = 'public-job-offer-get-failure';
